<!--  -->
<template>
    <div class="business-content-main outconfirm-content">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div>
            <div class="search-ctn" style="min-height: 0">
                <div class="search-ctn-left">
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询（F2）</el-button>
                    <el-button v-if="permission.receiptConfirms" size="small" type="warning" icon="el-icon-document-copy" class="search-btn" @click="batchComfirms()">{{
                        permission.receiptConfirms
                    }}</el-button>
                    <el-button size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()" v-if="permission.printSettlement">{{
                        permission.printSettlement
                    }}</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="exportForm()" v-if="permission.exportSettlement">
                        <i class="fa fa-file-excel-o"></i>
                        {{ permission.exportSettlement }}
                    </el-button>
                </div>
                <div class="search-ctn-right">
                    <div class="section-summary">
                        <div>
                            <span>合计：{{ summaryStr }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-container style="height: 450px; width: 60%; margin-right: 10px">
                    <el-table
                        highlight-current-row
                        style="width: 100%"
                        :header-cell-style="{ background: '#F2F6FC' }"
                        border=""
                        :data="tableData"
                        height="450"
                        ref="multipleTable"
                        :row-class-name="tableRowClassName"
                        @row-click="rowClick"
                        :row-key="getRowKeys"
                        @sort-change="sortChange"
                        v-el-table-infinite-scroll="tableLoad"
                        empty-text="暂无结算数据"
                    >
                        <el-table-column show-overflow-tooltip width="180" prop="OrderCode" label="结算单号"></el-table-column>
                        <el-table-column show-overflow-tooltip width="120" prop="EntpCusName" label="客户"></el-table-column>
                        <el-table-column show-overflow-tooltip width="80" prop="SumPayable" label="应收账款"></el-table-column>
                        <el-table-column show-overflow-tooltip width="80" prop="AlreadyPaid" label="已收金额"></el-table-column>
                        <el-table-column show-overflow-tooltip width="80" prop="UnPaid" label="余额">
                            <template slot-scope="scope">{{ scope.row.StateName == '已结算' ? 0 : scope.row.UnPaid }}</template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip width="80" prop="UnPaid" label="减收">
                            <template slot-scope="scope">{{ scope.row.StateName == '已结算' ? scope.row.UnPaid : 0 }}</template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip width="80" prop="StateName" label="状态">
                            <template slot-scope="scope">
                                <i v-if="scope.row.StateName == '已结算'" class="c-active">{{ scope.row.StateName }}</i>
                                <i v-else-if="scope.row.StateName == '已撤销'" class="cancel-active">{{ scope.row.StateName }}</i>
                                <i v-else-if="scope.row.StateName == '已结部分'" class="out-active">{{ scope.row.StateName }}</i>
                                <i v-else>{{ scope.row.StateName }}</i>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip sortable="custom" width="105px" prop="CreateTime" label="申请时间"></el-table-column>
                        <el-table-column show-overflow-tooltip width="70px" prop="Operator" label="申请人"></el-table-column>
                        <el-table-column show-overflow-tooltip min-width="100" prop="Remark" label="备注"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="110px">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="permission.settleReciept && !scope.row.IsSettle && scope.row.StateName != '已撤销'"
                                    :title="permission.settleReciept"
                                    size="mini"
                                    type="text"
                                    @click="settleUp(scope.row)"
                                    >{{ permission.settleReciept }}</el-button
                                >
                                <el-button
                                    v-if="permission.stateBack && scope.row.IsSettle"
                                    :title="permission.stateBack"
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    @click="backState(scope.row.SettleId)"
                                    >{{ permission.stateBack }}</el-button
                                >
                                <el-button
                                    v-if="permission.cancel && scope.row.State == 1 && scope.row.StateName != '已结算' && scope.row.StateName != '已结部分'"
                                    :title="permission.cancel"
                                    size="mini"
                                    type="text"
                                    style="color: orange"
                                    @click="cancelSettlement(scope.row.SettleId)"
                                    >{{ permission.cancel }}</el-button
                                >
                                <el-button
                                    v-if="permission.del && scope.row.StateName == '已撤销'"
                                    :title="permission.del"
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    @click="delSettlement(scope.row.SettleId)"
                                    >{{ permission.del }}</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </el-container>
                <el-container style="height: 450px; width: 38%">
                    <el-table
                        v-loading="loading"
                        style="width: 100%"
                        :header-cell-style="{ background: '#F2F6FC' }"
                        border=""
                        :data="orderApplyData"
                        height="450"
                        ref="multipleTable2"
                        :row-class-name="tableRowClassName"
                        empty-text="暂无收款数据"
                    >
                        <el-table-column show-overflow-tooltip width="180" prop="RecordCode" label="收款单号"></el-table-column>
                        <el-table-column show-overflow-tooltip width="100" prop="ApplyPay" label="收款金额"></el-table-column>
                        <el-table-column show-overflow-tooltip width="80px" prop="Operator" label="收款人"></el-table-column>
                        <el-table-column show-overflow-tooltip sortable="custom" width="105px" prop="PayTime" label="收款时间"></el-table-column>
                        <el-table-column show-overflow-tooltip sortable="custom" width="160px" prop="CreateTime" label="操作时间"></el-table-column>
                        <el-table-column show-overflow-tooltip width="200px" prop="Remark" label="备注"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="80px">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="permission.checkReciept && !scope.row.IsConfirm"
                                    :title="permission.checkReciept"
                                    size="mini"
                                    type="text"
                                    @click="confirmApply(scope.row)"
                                    >{{ permission.checkReciept }}</el-button
                                >
                                <el-button
                                    v-if="permission.cancelReciept && !scope.row.IsSettle"
                                    :title="permission.cancelReciept"
                                    size="mini"
                                    type="text"
                                    style="color: orange"
                                    @click="cancelApply(scope.row)"
                                    >{{ permission.cancelReciept }}</el-button
                                >
                                <el-button
                                    v-if="permission.stateConfirmBack && scope.row.IsSettle && currentRow.StateName != '已结算' && currentRow.StateName != '已撤销'"
                                    :title="permission.stateConfirmBack"
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    @click="backStateApply(scope.row)"
                                    >{{ permission.stateConfirmBack }}</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </el-container>
            </div>
            <div class="section-title">
                <div>
                    <span>{{ !orderCode ? '' : '【' + orderCode + '】' }}申请明细</span>
                </div>
            </div>
            <div>
                <el-table
                    v-loading="detailLoading"
                    class="detail-table"
                    :data="orderDetailData"
                    style="width: 100%"
                    height="250px"
                    border=""
                    :row-key="getDetailRowKeys"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    empty-text="点击结算列表即可查看申请明细"
                    @selection-change="handleSelectionChange"
                    :summary-method="getSummaries"
                    show-summary
                    ref="detailTable"
                >
                    <el-table-column type="selection" width="50" reserve-selection :selectable="selectInit"></el-table-column>
                    <el-table-column prop="PRType" label="单据类型" min-width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="OrderCode" label="业务单号" min-width="170" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Date" label="日期" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="ApplyAmount" label="申请金额" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.ApplyAmount : -scope.row.ApplyAmount }}</template>
                    </el-table-column>
                    <el-table-column prop="AlreadyPaid" label="已收金额" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.AlreadyPaid : -scope.row.AlreadyPaid }}</template>
                    </el-table-column>
                    <el-table-column label="未收金额" prop="UnPaid" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">{{
                            scope.row.OrderType == 0 ? (scope.row.ApplyAmount - scope.row.AlreadyPaid).toFixed(2) : -(scope.row.ApplyAmount - scope.row.AlreadyPaid).toFixed(2)
                        }}</template>
                    </el-table-column>
                    <el-table-column prop="Remark" label="备注" min-width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作" width="100px">
                        <template slot-scope="scope">
                            <el-button
                                v-if="
                                    permission.cancelDetail &&
                                    scope.row.OrderState == 1 &&
                                    currentRow.StateName != '已结算' &&
                                    currentRow.StateName != '已撤销' &&
                                    scope.row.AlreadyPaid == 0
                                "
                                :title="permission.cancelDetail"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="cancelDetail(scope.row)"
                                >{{ permission.cancelDetail }}</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                title="结算单据搜索"
                :visible.sync="dialogVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="search-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="客户">
                            <el-select
                                class="search-item"
                                size="small"
                                style="width: 100%"
                                v-model="searchData.Keyword"
                                remote
                                filterable
                                allow-create
                                placeholder="客户名称/电话"
                                :remote-method="searchCustom"
                                v-select-scroll-more="searchCustomLoad"
                                popper-class="my-select"
                            >
                                <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                        <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单号">
                            <el-input
                                class="search-item"
                                style="width: 100%"
                                size="small"
                                v-model.trim="searchData.OrderCode"
                                v-filter-special-char="searchData.OrderCode"
                                placeholder="请输入结算单号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="单据状态">
                            <el-select class="search-item" style="width: 100%" size="small" v-model="searchData.State">
                                <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="申请人">
                            <el-select v-model="searchData.ApplyId" style="width: 100%" class="search-item" size="small" filterable clearable placeholder="请选择">
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="申请日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime1"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate1TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                :title="cusName ? '【' + cusName + '】确认收款' : '确认收款'"
                :visible.sync="isShowConfirmDialog"
                :append-to-body="true"
                v-dialog-drag
                :modal="false"
                width="1000px"
                lock-scroll
                id="confirm-dialog"
                style="margin-left: -600px"
            >
                <div v-if="isShowConfirmDialog" class="settle-op-content">
                    <ConfirmReceipt
                        ref="confirmReceipt"
                        @closeDialog="closeDialog"
                        :applyList="multipleSelection"
                        :dataLength="orderDetailData.length"
                        :settleId="currentRow.SettleId"
                    ></ConfirmReceipt>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printVisible" width="870px">
                <div class="dialog-content" v-if="printVisible">
                    <PrintContent
                        @closeDialog="
                            () => {
                                printVisible = false;
                            }
                        "
                        :SettleId="currentRow.SettleId"
                    ></PrintContent>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                :title="cusName ? '【' + cusName + '核算结款' : '核算结款'"
                :visible.sync="dialogSettleUpVisible"
                width="1000px"
                append-to-body
            >
                <div class="dialog-content" v-if="dialogSettleUpVisible">
                    <SettleUp ref="settleUp" @closeSettleUp="closeSettleUp" :SettleId="settleId" :SumPayable="sumPayable" :Type="0" :UnPaid="unPaid"></SettleUp>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import ConfirmReceipt from '@/components/business/revenue_n/confirmReceipt';
import PrintContent from '@/components/business/revenue/printSettlement';
import SettleUp from '@/components/business/revenue_n/settleUp';
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
export default {
    mixins: [],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        ConfirmReceipt,
        PrintContent,
        SettleUp
    },
    data() {
        return {
            summaryStr: '',
            orderCode: '',
            datetime1:[],
            loading: '',
            detailLoading: '',
            cusName: '',
            multipleSelection: null,
            dialogVisible: false,
            printVisible: false,
            isShowConfirmDialog: false,
            dialogSettleUpVisible: false,
            scanData: '',
            dataindex: 0,
            stopFresh: false,
            isShowSummary: false,
            settleId: '',
            unPaid: 0,
            sumPayable: 0,
            searchData: {
                State: '',
                Keyword: '',
                OrderCode: '',
                ApplyId: '',
                StartDate: '',
                EndDate: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: 15
            },
            searchParams: {},
            currentRow: {},
            tableData: [],
            orderDetailData: [],
            orderApplyData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '-1' },
                { Text: '未提交', Value: '0' },
                { Text: '已提交', Value: '1' },
                { Text: '已结部分', Value: '3' },
                { Text: '已结算', Value: '4' },
                { Text: '已撤销', Value: '2' }
            ],
            SIdList: [],
            cusId: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        if (this.$route.query.code) this.searchData.OrderCode = this.$route.query.code;

        this.getTableData();
        this.permission = this.$util.getPermission('CustomerSettlement');
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                that.showSearchDialog();
            }
            if (key === 13) {
                if (that.dialogVisible) that.handleSearch();
                else if (that.isShowConfirmDialog) {
                    if (that.$refs.confirmReceipt) {
                        that.$refs.confirmReceipt.submitForm();
                    }
                }
            }
            if (key === 27) {
                if (that.dialogVisible) that.closeSearchDialog();
                else if (that.isShowConfirmDialog) that.isShowConfirmDialog = false;
            }
            //下键
            if (key == 40) {
                if (that.dataindex != that.tableDataLength - 1) {
                    if (that.currentRow && that.currentRow.SettleId) {
                        that.dataindex++;
                    } else that.dataindex = 0;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                            that.getOrderDetail();
                        }
                    });
                }
            }
            //上键
            if (key == 38) {
                if (that.dataindex != 0) {
                    that.dataindex--;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                            that.getOrderDetail();
                        }
                    });
                }
            }
        },
        tableLoad() {
            if (!this.stopFresh) {
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },
        showSearchDialog() {
            this.initSearchSelectData();
            this.dialogVisible = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
            this.currentRow = row;
            this.multipleSelection = [];
            this.$refs.detailTable.clearSelection();
            this.getOrderDetail();
            this.getRecieptDetail();
        },
        getOrderDetail() {
            let item = this.currentRow;
            if (item) {
                this.orderCode = item.OrderCode;
                this.detailLoading = true;
                let url = '/api/RevenueManagement_N/GetSettlementsDetails';
                this.$util
                    .axiosGet({
                        url: url,
                        data: {
                            SId: item.SettleId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            this.orderDetailData = res.data;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.detailLoading = false;
                    });
            }
        },
        getRecieptDetail() {
            let item = this.currentRow;
            if (item) {
                this.orderCode = item.OrderCode;
                this.loading = true;
                let url = '/api/RevenueManagement_N/GetReceiptRecordsListBySId';
                this.$util
                    .axiosGet({
                        url: url,
                        data: {
                            SId: item.SettleId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            this.orderApplyData = res.data;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        initSearchSelectData() {
            //可以把这些常用的数据放到缓存里面
            this.getSIdList();
            this.searchCustom();
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        resetSearch() {
            this.searchData = {
                State: '',
                Keyword: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                ApplyId: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: 15
            };
            this.datetime1 = [];
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            let that = this;
            if (that.searchData.page == 1) {
                that.searchParams = { ...that.searchData };
            } else {
                that.searchParams.page = that.searchData.page;
            }
            that.stopFresh = true;

            that.$util
                .axiosGet({
                    url: '/api/RevenueManagement_N/GetCusSettlementsList',
                    data: that.searchParams
                })
                .then(res => {
                    let data = res.data;
                    that.tableDataLength = res.count;
                    if (!data) {
                        if (that.searchData.page == 1) that.tableData = [];
                        return;
                    }

                    that.summaryStr = data.SummaryStr;

                    let list = [...that.tableData, ...data.DataList];
                    that.tableData = list;

                    that.stopFresh = data.DataList.length < that.searchData.limit;
                });
        },
        handleSearch() {
            this.tableData = [];
            if (this.$refs.multipleTable) this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        confirm(item) {
            let that = this;
            if (item.SettleId && !item.IsSettle) {
                that.currentRow = item;
                that.multipleSelection = [];
                that.multipleSelection.push(item);
                that.cusName = that.multipleSelection[0].EntpCusName;
                that.isShowConfirmDialog = true;
            } else {
                that.$util.warningMsg('申请数据异常，请刷新后重新操作');
            }
        },
        batchComfirms() {
            let that = this;
            if (that.multipleSelection.length > 0) {
                that.cusName = that.multipleSelection[0].EntpCusName;
                that.isShowConfirmDialog = true;
            } else {
                that.$util.warningMsg('请先勾选需要申请的项');
            }
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.tableData = [];
            this.getTableData();
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.SettleId;
        },
        getDetailRowKeys(row) {
            return row.RecordId;
        },
        closeDialog(isEdit) {
            this.isShowConfirmDialog = false;
            let that = this;
            if (isEdit) {
                that.$refs.multipleTable.clearSelection();
                that.multipleSelection = null;
                that.getOrderDetail();
                that.getRecieptDetail();
            }
        },
        getSummaries(param) {
            const { data } = param;
            let applyAmountTotal = 0;
            let alreadyPaidTotal = 0;
            data.forEach(ele => {
                if (ele.OrderType == 0) {
                    applyAmountTotal = (Number(applyAmountTotal) + Number(ele.ApplyAmount)).toFixed(2);
                    alreadyPaidTotal = (Number(alreadyPaidTotal) + Number(ele.AlreadyPaid)).toFixed(2);
                } else {
                    applyAmountTotal = (Number(applyAmountTotal) - Number(ele.ApplyAmount)).toFixed(2);
                    alreadyPaidTotal = (Number(alreadyPaidTotal) - Number(ele.AlreadyPaid)).toFixed(2);
                }
            });
            return [
                '',
                '合计：' + this.orderDetailData.length,
                '',
                '',
                applyAmountTotal + ' 元',
                alreadyPaidTotal + ' 元',
                (applyAmountTotal - alreadyPaidTotal).toFixed(2) + ' 元',
                '',
                ''
            ];
        },
        selectInit(row, index) {
            //如果没有选中，要开放全部选择
            if (
                this.permission.cancelDetail &&
                row.OrderState == 1 &&
                this.currentRow.StateName != '已结算' &&
                this.currentRow.StateName != '已撤销' &&
                row.AlreadyPaid != row.ApplyPay
            )
                return true;
            else return false;
        },
        cancelDetail(item) {
            if (item) {
                if (this.orderDetailData && this.orderDetailData.length == 1) {
                    this.$confirm('当前仅有一条明细，您确定要撤销该结算单吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: false
                    })
                        .then(() => {
                            this.$util
                                .axiosPost({
                                    url: '/api/RevenueManagement_N/CancelSettlementDetails',
                                    data: {
                                        SettleId: this.currentRow.SettleId,
                                        RecordIds: [item.RecordId],
                                        CancelType: 1
                                    }
                                })
                                .then(res => {
                                    if (res.errcode == 0) {
                                        this.$util.successMsg('成功撤销结算单');
                                        for (let i = 0; i < this.tableData.length; i++) {
                                            if (this.tableData[i].SettleId == this.currentRow.SettleId) {
                                                this.tableData.splice(i, 1);
                                                this.currentRow = {};
                                                this.orderApplyData = [];
                                                this.orderDetailData = [];
                                                return;
                                            }
                                        }
                                    }
                                })
                                .catch(() => {});
                        })
                        .catch(() => {});
                } else {
                    this.$confirm('您确定要移除该条明细吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: false
                    })
                        .then(() => {
                            this.$util
                                .axiosPost({
                                    url: '/api/RevenueManagement_N/CancelSettlementDetails',
                                    data: {
                                        SettleId: this.currentRow.SettleId,
                                        RecordIds: [item.RecordId],
                                        CancelType: 1
                                    }
                                })
                                .then(res => {
                                    if (res.errcode == 0) {
                                        this.$util.successMsg('移除成功');
                                        for (let i = 0; i < this.orderDetailData.length; i++) {
                                            if (this.orderDetailData[i].RecordId == item.RecordId) {
                                                this.orderDetailData.splice(i, 1);

                                                if (item.OrderType == 0) {
                                                    this.currentRow.SumPayable = (this.currentRow.SumPayable - item.ApplyAmount).toFixed(2);
                                                    this.currentRow.UnPaid = (this.currentRow.UnPaid - item.ApplyAmount).toFixed(2);
                                                } else {
                                                    this.currentRow.SumPayable = (this.currentRow.SumPayable + item.ApplyAmount).toFixed(2);
                                                    this.currentRow.UnPaid = (this.currentRow.UnPaid + item.ApplyAmount).toFixed(2);
                                                }
                                                return;
                                            }
                                        }
                                    }
                                })
                                .catch(() => {});
                        })
                        .catch(() => {});
                }
            } else this.$util.warningMsg('需要移除的明细数据异常，请刷新后重新操作');
        },
        print() {
            if (!this.currentRow) {
                this.$util.warningMsg('请选择一张结算单进行打印');
                return;
            }
            this.printVisible = true;
        },
        exportForm() {
            if (!this.currentRow) {
                this.$util.warningMsg('请选择导出一张结算单');
                return;
            }
            this.$util.exportFile({
                url: '/api/RevenueManagement/ExportSettlements',
                data: {
                    SettleId: this.currentRow.SettleId
                }
            });
        },
        settleUp(item) {
            if (item) {
                this.dialogSettleUpVisible = true;
                this.settleId = item.SettleId;
                this.sumPayable = item.SumPayable;
                this.EntpCusName = item.CName;
                this.unPaid = item.UnPaid;
            } else {
                this.$util.warningMsg('需要结款的往来数据异常，请刷新后重试');
            }
        },
        closeSettleUp(paid) {
            this.dialogSettleUpVisible = false;
            if (typeof paid !== 'undefined' && paid !== null) {
                this.tableData.forEach(f => {
                    if (f.SettleId == this.settleId) {
                        f.IsSettle = true;
                        f.StateName = '已结算';
                        // f.UnPaid = (f.UnPaid - Number(paid)).toFixed(2);
                        // f.AlreadyPaid = (f.AlreadyPaid + Number(paid)).toFixed(2);

                        f.UnPaid = Number(paid).toFixed(2);
                        return;
                    }
                });
                this.getOrderDetail();
                this.getRecieptDetail();
            }
        },
        cancelSettlement(settleId) {
            if (settleId) {
                this.$confirm('您确定要撤销该结算单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.$util
                            .axiosPost({
                                url: '/api/RevenueManagement_N/CancelSettlementDetails',
                                data: {
                                    SettleId: settleId,
                                    CancelType: 0
                                }
                            })
                            .then(res => {
                                this.$util.successMsg('撤销成功');
                                for (let index = 0; index < this.tableData.length; index++) {
                                    if (this.tableData[index].SettleId == settleId) {
                                        this.tableData.splice(index, 1);
                                        this.currentRow = {};
                                        this.orderApplyData = [];
                                        this.orderDetailData = [];
                                        return;
                                    }
                                }
                            })
                            .catch(() => {});
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请刷新后重新操作');
            }
        },
        delSettlement(settleId) {
            if (settleId) {
                this.$confirm('您确定要删除该结算单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement/DelSettlementDatas?SettleId=${settleId}`,
                                hideLoading: true
                            })
                            .then(res => {
                                this.$util.successMsg('删除成功');
                                for (let index = 0; index < this.tableData.length; index++) {
                                    if (this.tableData[index].SettleId == settleId) {
                                        this.tableData.splice(index, 1);
                                        return;
                                    }
                                }
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请刷新后重新操作');
            }
        },
        backState(id) {
            if (id) {
                this.$confirm('是否回退结算单的状态吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement_N/BackSettleStates?SettleId=${id}`
                            })
                            .then(res => {
                                if (res.errcode == 0) {
                                    this.$util.successMsg('回退状态成功');

                                    this.tableData.forEach(f => {
                                        if (f.SettleId == id) {
                                            f.IsSettle = false;
                                            f.AlreadyPaid = f.SumPayable;
                                            f.UnPaid = 0;
                                            if (f.AlreadyPaid != 0) f.StateName = '已结部分';
                                            else if (f.AlreadyPaid == 0) f.StateName = '已提交';

                                            return;
                                        }
                                    });
                                }
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效申请款项');
            }
        },
        confirmApply(item) {
            if (item) {
                this.$confirm('是否确认该条收款？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: '/api/RevenueManagement_N/ConfirmApplyRecords',
                                data: {
                                    RecordId: item.RecordId,
                                    OPType: 0
                                }
                            })
                            .then(res => {
                                if (res.errcode == 0) {
                                    this.$util.successMsg('确认款项成功');
                                    this.currentRow.AlreadyPaid = (Number(this.currentRow.AlreadyPaid) + Number(item.ApplyPay)).toFixed(2);
                                    this.currentRow.UnPaid = (this.currentRow.UnPaid - Number(item.ApplyPay)).toFixed(2);
                                    this.currentRow.StateName = '已结部分';
                                    item.IsSettle = true;
                                    item.IsConfirm = true;
                                }
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效申请款项');
            }
        },
        cancelApply(item) {
            if (item) {
                this.$confirm('是否要撤销该条款项，撤销后将无法恢复？', '提示', {
                    confirmButtonText: '确定撤销',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement_N/CancelApplyRecords?RecordId=${item.RecordId}`
                            })
                            .then(res => {
                                this.$util.successMsg('撤销申请成功');
                                for (let i = 0; i < this.orderApplyData.length; i++) {
                                    if (this.orderApplyData[i].RecordId == item.RecordId) {
                                        this.orderApplyData.splice(i, 1);
                                        this.getOrderDetail();
                                        return;
                                    }
                                }
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择撤销有效申请款项');
            }
        },
        backStateApply(item) {
            if (item) {
                this.$confirm('是否回退该条款项的确认状态？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement_N/BackRecordStates?RecordId=${item.RecordId}`
                            })
                            .then(res => {
                                this.$util.successMsg('回退状态成功');
                                this.orderApplyData.forEach(f => {
                                    if (f.RecordId == item.RecordId) {
                                        f.IsSettle = false;
                                        f.IsConfirm = false;
                                        return;
                                    }
                                });
                                if (this.orderApplyData.length == 1) {
                                    this.currentRow.AlreadyPaid = 0;
                                    this.currentRow.UnPaid = this.currentRow.SumPayable.toFixed(2);
                                } else {
                                    this.currentRow.AlreadyPaid = (this.currentRow.AlreadyPaid - Number(item.ApplyPay)).toFixed(2);
                                    this.currentRow.UnPaid = (this.currentRow.UnPaid + Number(item.ApplyPay)).toFixed(2);
                                }
                                if (this.currentRow.AlreadyPaid == 0) this.currentRow.StateName = '已提交';
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效申请款项');
            }
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 12.5%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
#search-dc-dialog,
#confirm-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
#confirm-dialog::-webkit-scrollbar {
    display: none;
}
.v-content {
    width: 100%;
    height: calc(100vh);
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.table-ctn {
    display: flex;
    width: 100%;
    margin-bottom: 10px;
}
</style>
<style lang="less">
.outconfirm-content {
    .el-table {
        margin-bottom: 0px;

        th {
            padding: 4px 0;
        }
    }
    .detail-table {
        .el-table__body {
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }

                td {
                    padding: 2px 0;
                }
            }
        }
        .el-table__footer {
            td {
                padding: 4px 0;
            }
        }
    }
}
.el-table__row {
    td:not(is-hidden):last-child {
        border-left: 1px solid #ebeef5;
    }
}
.el-table__header {
    th:not(is-hidden):last-child {
        border-left: 1px solid #ebeef5;
    }
}
.el-table {
    overflow: visible !important;
}
</style>
